import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getShiftIntroSource = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.shiftIntroSource;
  }
);
